var exports = {
  "kL": "x31de4314--58cba9--container",
  "tp": "x31de4314--58cba9--table",
  "LG": "x31de4314--58cba9--table-header",
  "yF": "x31de4314--58cba9--divider",
  "RP": "x31de4314--58cba9--header-cell",
  "nZ": "x31de4314--58cba9--offers-link-block",
  "zt": "x31de4314--58cba9--offers-link",
};

module.exports = exports;
